export { default as DateReminder } from './DateReminder/DateReminder';
export { default as ControlResource } from './Resource/ControlResource';
export { default as ControlPageSidebar } from './ControlPageSidebar';
export { default as ControlPage } from './ControlPage';



// WEBPACK FOOTER //
// ./src/pages/Control/index.js